import { ReactElement } from 'react'
import { FileUploader } from '../../../components'
import { useDispatch } from 'react-redux'
import { setImage } from '../../../redux/addMaterial/actions'

const Image = (): ReactElement => {
  const dispatch = useDispatch()

  return (
    <FileUploader
      type="image"
      onUploadSuccess={(file) => {
        dispatch(setImage(file))
      }}
    />
  )
}

export default Image
